import { BarChart3, Boxes, ChevronLeft, LayoutDashboard, Menu, PackageSearch, ShoppingBag, Sparkles, Target, Users, X } from 'lucide-react'
import { useState, type ReactNode } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { workspaceModules, type ModuleId } from '../lib/modules'
import { dateLabel } from '../lib/format'
import { usePublicDemo } from '../data/PublicDemoContext'
import { BrandLockup } from './ui'
import { LanguageToggle, useI18n } from '../i18n'

const icons = {
  overview: LayoutDashboard,
  sales: ShoppingBag,
  customer: Users,
  marketing: Target,
  inventory: PackageSearch,
  operations: Boxes,
  metrics: BarChart3,
} satisfies Record<ModuleId, typeof LayoutDashboard>

export function WorkspaceShell({ activeModule, children }: { activeModule: ModuleId; children: ReactNode }) {
  const data = usePublicDemo()
  const [open, setOpen] = useState(false)
  const { copy, locale, path } = useI18n()

  return (
    <div className="workspace-root">
      <header className="workspace-mobile-header">
        <BrandLockup to="/analytics/overview" />
        <div className="workspace-mobile-actions"><LanguageToggle compact /><button onClick={() => setOpen(!open)} aria-label={copy.common.toggleAnalyticsNavigation} aria-expanded={open}>{open ? <X size={20} /> : <Menu size={20} />}</button></div>
      </header>
      {open && <button className="workspace-scrim" onClick={() => setOpen(false)} aria-label={copy.common.closeAnalyticsNavigation} />}
      <aside className={`workspace-sidebar${open ? ' open' : ''}`}>
        <div className="workspace-brand"><BrandLockup to="/analytics/overview" /><span>{copy.common.analyticsWorkspace.toUpperCase()}</span><LanguageToggle /></div>
        <nav className="workspace-nav" aria-label={copy.common.analyticsWorkspace}>
          {workspaceModules.map((module) => {
            const Icon = icons[module.id]
            if (module.status === 'available' && module.path) {
              return <NavLink key={module.id} to={path(module.path)} className={module.id === activeModule ? 'active' : ''} onClick={() => setOpen(false)}><Icon size={17} /><span>{copy.navigation[module.id]}</span></NavLink>
            }
            return <span key={module.id} className="planned" aria-disabled="true"><Icon size={17} /><span>{copy.navigation[module.id]}</span><small>{copy.common.planned}</small></span>
          })}
        </nav>
        <div className="workspace-sidebar-footer">
          <div><Sparkles size={15} /><span>{copy.common.syntheticData}</span></div>
          <p>{copy.common.dataAsOf} {dateLabel(data.data_as_of, locale)}</p>
          <Link to={path('/')}><ChevronLeft size={15} /> {copy.common.backToStory}</Link>
        </div>
      </aside>
      <main className="workspace-main">{children}</main>
    </div>
  )
}
